import axiosClient from "./axiosClient";

/** Dispatched on `window` after ticket create/update so the sidebar badge can refetch. */
export const TICKET_STATS_CHANGED_EVENT = "fes-ticket-stats-changed";

function notifyTicketStatsChanged() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(TICKET_STATS_CHANGED_EVENT));
  }
}

export const getTickets = async (params = {}) => {
  const res = await axiosClient.get("/tickets/", { params });
  return res.data;
};

export const getTicketStats = async (params = {}) => {
  const res = await axiosClient.get("/tickets/stats/", { params });
  return res.data;
};

export const createTicket = async (data) => {
  const res = await axiosClient.post("/tickets/create/", data);
  notifyTicketStatsChanged();
  return res.data;
};

export const updateTicket = async (ticketId, data) => {
  const res = await axiosClient.put(`/tickets/${ticketId}/update/`, data);
  notifyTicketStatsChanged();
  return res.data;
};

export const getTicketComments = async (ticketId) => {
  const res = await axiosClient.get(`/tickets/${ticketId}/comments/`);
  return res.data;
};

export const createTicketComment = async (ticketId, data) => {
  const res = await axiosClient.post(`/tickets/${ticketId}/comments/create/`, data);
  return res.data;
};
